import { render, staticRenderFns } from "./UserCaseDetail.vue?vue&type=template&id=07cbd265&scoped=true&"
import script from "./UserCaseDetail.vue?vue&type=script&lang=js&"
export * from "./UserCaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cbd265",
  null
  
)

export default component.exports